import { FC } from 'react';
import { CheckOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { Typography } from 'antd';
import styled from 'styled-components';

import { resolveCountry } from '@/shared/constants/countries-list';
import { dates } from '@/shared/utils/dates';

import { Container, Row } from '../../layout';

type ListItemProps = {
  title: string | undefined;
  showStartDate: boolean;
  date?: Date;
  startDate?: Date;
  country?: string;
  isSelected: boolean;
};

export const ListItem: FC<ListItemProps> = ({
  title,
  showStartDate,
  date,
  startDate,
  country,
  isSelected,
}) => {
  return (
    <ListItemContainer nowrap gap={8}>
      <IconListItem>
        <InfoCircleOutlined style={{ fontSize: 20, color: '#605844' }} />
      </IconListItem>

      <Container width="100%">
        <Row nowrap justifyContent="space-between" alignCenter>
          <Typography.Text strong>{title}</Typography.Text>

          {isSelected && <CheckOutlined style={{ fontSize: 18, color: '#605844' }} />}
        </Row>

        <Row nowrap alignCenter>
          <Typography.Text type="secondary">
            {!showStartDate && (date ? dates.formatShort(date) : '')}
            {showStartDate && <>Start date {startDate ? dates.formatShort(startDate) : ''}</>}
            &nbsp;•&nbsp;
          </Typography.Text>
          {/* <Typography.Text type="secondary">{formattedDate} •&nbsp;</Typography.Text> */}
          <Typography.Text type="secondary">
            {country && resolveCountry(country, true, false)}
          </Typography.Text>
        </Row>
      </Container>
    </ListItemContainer>
  );
};

const IconListItem = styled.div`
  padding: 8px;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background-color: #5959561f;
`;

const ListItemContainer = styled(Row)`
  padding-top: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid #d9d9d9;
  cursor: pointer;
  &:hover {
    opacity: 0.6;
  }
`;
